interface ParsedFileItem {
  name: string;
  quantity: number;
  description: string;
}

interface ParseResult {
  items: ParsedFileItem[];
  valid: boolean;
}

export function parseTxtFile(content: string): ParseResult {
  const lines = content.split("\n").map((l) => l.trim()).filter(Boolean);
  if (!lines.length) return { items: [], valid: false };
  const items = lines.map((name) => ({ name, quantity: 1, description: "" }));
  const valid = items.every((i) => i.name.length > 0 && i.name.length <= 200);
  return { items, valid };
}

export function parseCsvFile(content: string): ParseResult {
  const lines = content.split("\n").map((l) => l.trim()).filter(Boolean);
  if (!lines.length) return { items: [], valid: false };

  // Detect header row
  const first = lines[0].toLowerCase();
  const hasHeader = first.includes("name") || first.includes("item");
  const dataLines = hasHeader ? lines.slice(1) : lines;
  if (!dataLines.length) return { items: [], valid: false };

  // Parse columns: split by comma, first col = name, optional qty, optional description
  const items: ParsedFileItem[] = [];
  for (const line of dataLines) {
    const cols = line.split(",").map((c) => c.trim().replace(/^"|"$/g, ""));
    const name = cols[0] ?? "";
    if (!name) continue;
    const qty = cols[1] ? parseInt(cols[1], 10) : NaN;
    items.push({
      name,
      quantity: Number.isFinite(qty) && qty > 0 ? qty : 1,
      description: cols[2] ?? "",
    });
  }

  // Valid if we got items and most rows parsed to reasonable names
  const valid = items.length > 0 && items.every((i) => i.name.length > 0 && i.name.length <= 200);
  return { items, valid };
}

export function parseItemFile(content: string, fileName: string): ParseResult {
  if (fileName.toLowerCase().endsWith(".csv")) return parseCsvFile(content);
  return parseTxtFile(content);
}
